// Retry mechanism for failed chunk loads
let chunkRetryCount = 0;
const maxChunkRetries = 2;

// Handle chunk loading errors
window.addEventListener('error', (event) => {
    const target = event.target || event.srcElement;
    const isChunkLoadError = target &&
        (target.tagName === 'SCRIPT' || target.tagName === 'LINK') &&
        target.src && target.src.includes('.chunk.');

    if (isChunkLoadError && chunkRetryCount < maxChunkRetries) {
        chunkRetryCount++;
        console.warn(`Chunk load failed, retrying... (${chunkRetryCount}/${maxChunkRetries})`);

        // Reload the page after a short delay
        setTimeout(() => {
            window.location.reload();
        }, 1000);

        event.preventDefault();
        return;
    }

    if (isChunkLoadError && chunkRetryCount >= maxChunkRetries) {
        console.error('Chunk loading failed after maximum retries');
        // You could show a user-friendly message here
        // alert('Unable to load application. Please refresh the page.');
    }
});

// Reset retry count on successful page load
window.addEventListener('load', () => {
    chunkRetryCount = 0;
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {};